import { Coordinates } from "./useMapCenter";

const getNearPoint = (
  initialCoordinates: Coordinates,
  distance: number
): Coordinates => {
  const R = 6378.1; // Radius of the Earth
  const brng = 1.57; // Bearing is 90 degrees converted to radians.

  let lat1 = initialCoordinates[1]; // Current lat point converted to radians
  let lon1 = initialCoordinates[0]; // Current long point converted to radians
  lat1 = lat1 * (Math.PI / 180); // Current lat point converted to radians
  lon1 = lon1 * (Math.PI / 180); // Current long point converted to radians

  let lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(distance / R) +
      Math.cos(lat1) * Math.sin(distance / R) * Math.cos(brng)
  );

  let lon2 =
    lon1 +
    Math.atan2(
      Math.sin(brng) * Math.sin(distance / R) * Math.cos(lat1),
      Math.cos(distance / R) - Math.sin(lat1) * Math.sin(lat2)
    );

  lat2 = lat2 * (180 / Math.PI);
  lon2 = lon2 * (180 / Math.PI);

  return [lon2, lat2];
};

export default getNearPoint;
